module.exports = __webpack_public_path__ + "static/Content_Marketing-4a298051b8ff23ca83fb212189255ea7.svg";